export function getAngieUpwardAdjustments(tooltips = {}) {
  return {
    capitalised_expense_in_statements: {
      label:
        "Relevant expense amounts capitalised in group financial statements into a non-financial asset or liability - s413(3)(a)",
      type: "positive",
      notes: tooltips.capitalised_expense_in_statements,
    },
    capitalised_income_written_off: {
      label:
        "Amounts of capitalised income written off in respect of a non-financial asset or liability that are included in NGIE by virtue of s410(5) - s413(3)(b)",
      type: "positive",
      notes: tooltips.capitalised_income_written_off,
    },
    expense_amount_recognised_in_equity_or_shareholders: {
      label:
        "Relevant expense amounts recognised in equity or shareholders funds in group accounts (not in P&L/OCI) and is/would be brought into account for corporate tax purposes - s413(3)(c)",
      type: "positive",
      notes: tooltips.expense_amount_recognised_in_equity_or_shareholders,
    },
    upward_amount_under_s330za: {
      label:
        "Amounts treated as deductible, for periods of account ending on or after 6 April 2020 subject to transitional provisions, under s330ZA CTA 2009 by a UK group company that have not previously been included in ANGIE - s413(3)(ca)",
      type: "positive",
      notes: tooltips.upward_amount_under_s330za,
    },
    post_2020_transitional_amounts_s607za_cta2009: {
      label:
        "Amounts that would be brought in, for periods of account ending on or after 6 April 2020 subject to transitional provisions, under s607ZA CTA 2009 by a UK group company had a Disregard Regulation election been made and that have not previously been included in ANGIE - s413(3)(cb)",
      type: "positive",
      notes: tooltips.post_2020_transitional_amounts_s607za_cta2009,
    },
    post_2020_income_amounts_s330za_transitional: {
      label:
        "Income amounts under a loan relationship, for periods of account ending on or after 6 April 2020 subject to transitional provisions, that are not brought into account and are expected to be brought into account under s330ZA for another accounting period - s413(c)(cc)",
      type: "positive",
      notes: tooltips.post_2020_income_amounts_s330za_transitional,
    },
    post_2020_derivative_income_s607za: {
      label:
        "Income amounts under a derivative contract, for periods of account ending on or after 6 April 2020 subject to transitional provisions, that are not brought into account by a UK group company, but would be expected to be brought into account under s607ZA for another accounting period had a Disregard Regulation election been made - s413(3)(cc)",
      type: "positive",
      notes: tooltips.post_2020_derivative_income_s607za,
    },
    upward_amount_under_s330_cta_election: {
      label:
        "Amounts brought into account under a s330 CTA 2009 election made after 11 July 2023 that have not previously been included in ANGIE - s413(3)(cd)",
      type: "positive",
      notes: tooltips.upward_amount_under_s330_cta_election,
    },
    relevant_debt_release_tax_exempt_income: {
      label:
        "Income in group P&L that is a relevant income amount arising from certain debt releases or similar transactions that would benefit from a Corporation Tax exemption under s322(2), 323A and, for periods of account beginning on or after 1 January 2019, s358 or s359",
      type: "positive",
      notes: tooltips.relevant_debt_release_tax_exempt_income,
    },
  };
}

export function getAngieDownwardAdjustments(tooltips = {}) {
  return {
    capitalised_income_in_statements: {
      label:
        "Relevant income amounts capitalised in group financial statements into a non-financial asset or liability - s413(4)(a)",
      type: "negative",
      notes: tooltips.capitalised_income_in_statements,
    },
    capitalised_expense_written_off: {
      label:
        "Amounts included in net group-interest expense by virtue of s.410(3) (capitalised expense written off) in respect of a non-financial asset or liability - s413(4)(b)",
      type: "negative",
      notes: tooltips.capitalised_expense_written_off,
    },
    income_amount_recognised_in_equity_or_shareholders: {
      label:
        "Relevant income amounts recognised in equity or shareholders funds in group accounts (not in P&L/OCI) and is/would be brought into account for corporate tax purposes - s413(4)(c)",
      type: "negative",
      notes: tooltips.income_amount_recognised_in_equity_or_shareholders,
    },
    downward_amount_under_s330ZA: {
      label:
        "Expense amounts under a loan relationship, for periods of account ending on or after 6 April 2020 subject to transitional provisions, that are not brought into account and are expected to be brought into account under s330ZA for another accounting period - s413(4)(ca)",
      type: "negative",
      notes: tooltips.downward_amount_under_s330ZA,
    },
    post_2020_derivative_expense_s607za: {
      label:
        "Expense amounts under a derivative contract, for periods of account ending on or after 6 April 2020 subject to transitional provisions, that are not brought into account by a UK group company, but would be expected to be brought into account under s607ZA for another accounting period had a Disregard Regulation election been made - s413(4)(ca)",
      type: "negative",
      notes: tooltips.post_2020_derivative_expense_s607za,
    },
    downward_amount_under_s330_cta_election: {
      label:
        "Amounts prevented from being brought into account under a s330 CTA 2009 election made after 11 July 2023 - s413(4)(cb)",
      type: "negative",
      notes: tooltips.downward_amount_under_s330_cta_election,
    },
    expense_amount_excluded_for_s322_2_or_cta2009: {
      label:
        "Expense in group P&L that is a relevant expense amount arising from certain debt releases or similar transactions that would benefit from a Corporation Tax exemption under s323A and, for periods of account beginning on or after 1 January 2019, s354 - s413(4)(d)",
      type: "negative",
      notes: tooltips.expense_amount_excluded_for_s322_2_or_cta2009,
    },
    expense_amount_for_dividends_on_preference_shares: {
      label:
        "Expense in group P&L that is a relevant expense amount and is for dividends payable on preference shares (if accounted for as financial liability) - s413(4)(e)",
      type: "negative",
      notes: tooltips.expense_amount_for_dividends_on_preference_shares,
    },
  };
}

export function getAngieGroupMismatchAdjustments(tooltips = {}) {
  return {
    mismatches_regulation_2_adjustments: {
      label:
        "Adjustments in respect of certain loan relationships existing on 1 April 2017 which were subject to fair value accounting or designated fair value hedge accounting in the group accounts - Regulation 2",
      type: null,
      notes: tooltips.mismatches_regulation_2_adjustments,
    },
    mismatches_regulation_3_adjustments: {
      label:
        "Adjustments in respect of loan relationships derecognised from the consolidated financial statements prior to 1 April 2017 without s361/362 CTA 2009 applying - Regulation 3",
      type: null,
      notes: tooltips.mismatches_regulation_3_adjustments,
    },
    mismatches_regulation_4_adjustments: {
      label:
        "Adjustments in respect of asset backed pension arrangements treated as acceptable structured finance arrangements giving rise to deemed interest deductions - Regulation 4",
      type: null,
      notes: tooltips.mismatches_regulation_4_adjustments,
    },
  };
}

export function getAngieInterestAllowanceAlternativeCalculation(tooltips = {}) {
  return {
    capitalised_upward_interest_adjustment: {
      label:
        "Reversal of s413(3)(a) adjustment above in respect of GAAP-taxable assets, such that amounts capitalised into GAAP-taxable assets or liabilities are not included in ANGIE - s423(2)(a)",
      type: "negative",
      notes: tooltips.capitalised_upward_interest_adjustment,
    },
    capitalised_downward_interest_adjustment: {
      label:
        "Reversal of s413(3)(b) adjustment above in respect of GAAP-taxable assets, such that amounts of capitalised income written off in respect of GAAP-taxable assets (that are not relevant assets) remain in NGIE - s423(2)(b)",
      type: "negative",
      notes: tooltips.capitalised_downward_interest_adjustment,
    },
    reversal_gaap_tax_assets_s423_2_a: {
      label:
        "Reversal of s413(4)(a) adjustment above in respect of GAAP-taxable assets, such that income amounts capitalised into GAAP-taxable assets or liabilities are not included in ANGIE - s423(2)(a)",
      type: null,
      notes: tooltips.reversal_gaap_tax_assets_s423_2_a,
    },
    gaap_assets_written_off_s423_2_b: {
      label:
        "Reversal of s413(4)(b) adjustment above in respect of GAAP-taxable assets, such that amounts written off in respect of GAAP-taxable assets (that are not relevant assets) remain in NGIE - s423(2)(b)",
      type: null,
      notes: tooltips.gaap_assets_written_off_s423_2_b,
    },
    gaap_relevant_expense_written_off_s423_2a: {
      label:
        "For periods beginning on or after 1 January 2019, adjustment to include the amounts written off relating to relevant expense amounts in respect of a GAAP-taxable asset that is a relevant asset - s423(2A)(a)",
      type: "negative",
      notes: tooltips.gaap_relevant_expense_written_off_s423_2a,
    },
    gaap_relevant_income_written_off_s423_2b: {
      label:
        "For periods beginning on or after 1 January 2019, adjustment to include the amounts written off relating to relevant income amounts in respect of a GAAP-taxable asset that is a relevant asset - s423(2A)(b)",
      type: "negative",
      notes: tooltips.gaap_relevant_income_written_off_s423_2b,
    },
    gaap_asset_carrying_value_relevant_expense_s423_2aa_a: {
      label:
        "For periods beginning on or after 1 April 2023, adjustment to include the amount of the carrying value of a GAAP-taxable asset appropriated (including under s173 TCGA 1992) which is attributable to a relevant expense amount - s423(2AA)(a)",
      type: "negative",
      notes: tooltips.gaap_asset_carrying_value_relevant_expense_s423_2aa_a,
    },
    gaap_asset_carrying_value_relevant_income_s423_2aa_b: {
      label:
        "Adjustment to downward adjustments to include the amount of the carrying value of a GAAP-taxable asset appropriated under s173 TCGA 1992 which is attributable to a relevant income amount - s423(2AA)(b)",
      type: "negative",
      notes: tooltips.gaap_asset_carrying_value_relevant_income_s423_2aa_b,
    },
  };
}

export function getAngieOther(tooltips = {}) {
  return {
    specialist_regimes_adjustments: {
      label: "Other adjustments required as a result of specialist regimes",
      type: null,
      notes: tooltips.specialist_regimes_adjustments,
    },
    miscellaneous_adjustments: {
      label: "Other adjustments for which there is no space above",
      type: null,
      notes: tooltips.miscellaneous_adjustments,
    },
  };
}

export function getAngieInterestAllowanceNonConsolidatedInvestment(
  tooltips = {},
) {
  return {
    angie_proportion_associated_groups_s427_4: {
      label:
        "Adjustment to include the appropriate proportion of the ANGIE of each associated worldwide group headed by a company specified in the election - s427(4)",
      type: "positive",
      notes: tooltips.angie_proportion_associated_groups_s427_4,
    },
  };
}

export function getAngieAdjustmentsForQualifyingInfrastructureCompanies(
  tooltips = {},
) {
  return {
    exclude_qic_income_exempt_s440_s442_2a: {
      label:
        "Adjustment to exclude relevant income amounts of a QIC that were exempted under s440 and are included in the group financial statements - s442(2)(a)",
      type: "positive",
      notes: tooltips.exclude_qic_income_exempt_s440_s442_2a,
    },
    exclude_qic_expense_exempt_s438_s442_2a: {
      label:
        "Adjustment to exclude relevant expense amounts of a QIC that were exempted under s438 (including as applied by s439) and are included in the group financial statements - s442(2)(a)",
      type: "negative",
      notes: tooltips.exclude_qic_expense_exempt_s438_s442_2a,
    },
  };
}

export function getAngieRowConfig(tooltips = {}) {
  return {
    // Upward Adjustments
    ...getAngieUpwardAdjustments(tooltips),

    // Downward Adjustments
    ...getAngieDownwardAdjustments(tooltips),

    // Group Mismatch Adjustments
    ...getAngieGroupMismatchAdjustments(tooltips),

    // Interest Allowance (Alternative Calculation) Election
    ...getAngieInterestAllowanceAlternativeCalculation(tooltips),

    // Other
    ...getAngieOther(tooltips),

    // Interest Allowance (non-consolidated investment election)
    ...getAngieInterestAllowanceNonConsolidatedInvestment(tooltips),

    // Adjustments for Qualifying Infrastructure Companies
    ...getAngieAdjustmentsForQualifyingInfrastructureCompanies(tooltips),
  };
}
